import React, { Fragment } from 'react'
import { Table } from 'stylist'
import { withRouter } from 'react-router-dom'
import Menu from './Menu'

const Show = ({
  data,
  fields,
  onRowClick,
  match: { path },
  match,
  ...props
}) => (
  <Fragment>
    <Menu data={data} match={match} {...props} />
    {data && (
      <Table data={[data]}>
        <Table.Row onClick={onRowClick}>
          {fields.map(field => (
            <Table.Column
              dataKey={field.name}
              label={field.label || field.name}
              key={field.name}
            />
          ))}
        </Table.Row>
      </Table>
    )}
  </Fragment>
)

export default withRouter(Show)



// WEBPACK FOOTER //
// ./src/components/BelongsTo/Show.js